import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import reportService from "./reportService";
import { flashMessage } from "../../../utils/flash";

const initialState = {
    actions: [],
    userActivity: null,
    customerOverviewData: undefined,
    isLoading: false,
    keySuccess: false,
    isSuccess: false,
    actionSuccess: false,
    key: null
}

export const reportSlice = createSlice({
    name: "report",
    initialState,
    reducers: {
        resetReportStatus: (state) => {
            state.isSuccess = false
            state.actionSuccess = false
            state.isLoading = false
            state.keySuccess = false
        },
        resetKeySuccess: (state) => {
            state.keySuccess = false
        },
        resetCustomerOverviewData: (state) => {
            state.customerOverviewData = undefined
            state.userActivity = undefined
            state.isLoading = false
        },
        resetReport: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
        // Get Actions
        .addCase(getActions.pending, (state) => {
            state.isLoading = true
        })
        .addCase(getActions.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.allActionActivity){
                state.actionSuccess = true;
                state.actions = action.payload.allActionActivity
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getActions.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })
        // Get User Activities
        .addCase(getUserActivities.pending, (state) => {
            state.isLoading = true
            state.userActivity = undefined
            flashMessage("info", 'Generating Report...');
        })
        .addCase(getUserActivities.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.allActivities){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.userActivity = action.payload.allActivities
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getUserActivities.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        // Get Customer overview
        .addCase(getCustomerOverview.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getCustomerOverview.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            // else if(action.payload.message){
            //     flashMessage("info", action.payload.message);
            //     state.customerOverviewData = undefined
            //     state.keySuccess = true;
            //     state.key = action.payload.key
            //     // dispatch(getOverviewData(state.key))
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getCustomerOverview.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        // Get Customer policy expiry
        .addCase(getCustomerPolicyExpiry.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getCustomerPolicyExpiry.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            // if(action.payload.message){
            //     flashMessage("info", action.payload.message);
            //     state.customerOverviewData = undefined
            //     state.keySuccess = true;
            //     state.key = action.payload.key
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getCustomerPolicyExpiry.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        // Get Customer payment
        .addCase(getCustomerPayment.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getCustomerPayment.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getCustomerPayment.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        // Get Agent Report
        .addCase(getAgentReport.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getAgentReport.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getAgentReport.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        // Get Agent Report
        .addCase(getRenewedPolicy.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getRenewedPolicy.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getRenewedPolicy.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        .addCase(getClaimReport.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getClaimReport.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getClaimReport.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        .addCase(getTrialBalance.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getTrialBalance.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getTrialBalance.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        .addCase(getIndividualSavingsReport.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getIndividualSavingsReport.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getIndividualSavingsReport.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        .addCase(getSavingsAccountReport.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getSavingsAccountReport.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getSavingsAccountReport.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        .addCase(getSavingsClaimReport.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getSavingsClaimReport.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getSavingsClaimReport.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        .addCase(getSavingsContributionReport.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getSavingsContributionReport.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getSavingsContributionReport.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        // Get Customer policy info
        .addCase(getCustomerPolicyInfo.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Processing Request...');
        })
        .addCase(getCustomerPolicyInfo.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.overviewData.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.customerOverviewData = action.payload.overviewData.customer_over_view_data
            }else if (action.payload.overviewData.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            // if(action.payload.message){
            //     flashMessage("info", action.payload.message);
            //     state.customerOverviewData = undefined
            //     state.keySuccess = true;
            //     state.key = action.payload.key
            } else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getCustomerPolicyInfo.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
        // Get overview data
        .addCase(getOverviewData.pending, (state) => {
            state.isLoading = true
            state.customerOverviewData = undefined
            flashMessage("info", 'Generating Report...');
        })
        .addCase(getOverviewData.fulfilled, (state, action) => {
            state.isLoading = false
            if(action.payload.customer_over_view_data){
                flashMessage("success", 'Report Successfully Generated');
                state.isSuccess = true;
                state.keySuccess = false;
                state.customerOverviewData = action.payload.customer_over_view_data
            }else if (action.payload.message === "Job not yet completed"){
                flashMessage("error", 'Job not completed, kindly try again later')
                state.isSuccess = false;
            }else if (action.payload.errors) {
                state.isError = true;
                state.message = action.payload.error;
                flashMessage("error", action.payload.error)   
            }
        })
        .addCase(getOverviewData.rejected, (state, action) =>{
            state.isLoading = false
            if (action.payload.errors) {
                state.isError = true;
                flashMessage("error", action.payload.errors);   
            }
        })    
    }
})

// Get actions
export const getActions = createAsyncThunk('/report/get/action', async(_, thunkAPI) => {
    try {
        return await reportService.getActions()
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get user activities
export const getUserActivities = createAsyncThunk('/report/get/userActivities', async(requestData, thunkAPI) => {
    try {
        return await reportService.getUserActivities(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get customer overview
export const getCustomerOverview = createAsyncThunk('/report/get/customerOverview', async(requestData, thunkAPI) => {
    try {
        return await reportService.getCustomerOverview(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get customer overview
export const getRenewedPolicy = createAsyncThunk('/report/get/renewedPolicy', async(requestData, thunkAPI) => {
    try {
        return await reportService.getRenewedPolicy(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get customer payment
export const getCustomerPayment = createAsyncThunk('/report/get/getCustomerPayment', async(requestData, thunkAPI) => {
    try {
        return await reportService.getCustomerPayment(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get agent report
export const getAgentReport = createAsyncThunk('/report/get/getAgentReport', async(requestData, thunkAPI) => {
    try {
        return await reportService.getAgentReport(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get claim report
export const getClaimReport = createAsyncThunk('/report/get/getClaimReport', async(requestData, thunkAPI) => {
    try {
        return await reportService.getClaimReport(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get customer policy info
export const getCustomerPolicyInfo = createAsyncThunk('/report/get/getCustomerPolicyInfo', async(requestData, thunkAPI) => {
    try {
        return await reportService.getCustomerPolicyInfo(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get customer policy expiry
export const getCustomerPolicyExpiry = createAsyncThunk('/report/get/getCustomerPolicyExpiry', async(requestData, thunkAPI) => {
    try {
        return await reportService.getCustomerPolicyExpiry(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
// Get customer policy expiry
export const getTrialBalance = createAsyncThunk('/report/get/getTrialBalance', async(requestData, thunkAPI) => {
    try {
        return await reportService.getTrialBalance(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});

export const getIndividualSavingsReport = createAsyncThunk('/report/get/getIndividualSavingsReport', async(requestData, thunkAPI) => {
    try {
        return await reportService.getIndividualSavings(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});
export const getSavingsAccountReport = createAsyncThunk('/report/get/getSavingsAccountReport', async(requestData, thunkAPI) => {
    try {
        return await reportService.getSavingsAccountReport(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});

export const getSavingsClaimReport = createAsyncThunk('/report/get/getSavingsClaimReport', async(requestData, thunkAPI) => {
    try {
        return await reportService.getSavingsClaimReport(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});

export const getSavingsContributionReport = createAsyncThunk('/report/get/getSavingsContributionReport', async(requestData, thunkAPI) => {
    try {
        return await reportService.getSavingsContributionReport(requestData)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});

// Get overview data
export const getOverviewData = createAsyncThunk('/report/get/overviewData', async(key, thunkAPI) => {
    try {
        return await reportService.getOverviewData(key)
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
});

export const { resetReport, resetReportStatus, resetCustomerOverviewData, resetKeySuccess } = reportSlice.actions;
export default reportSlice.reducer;